import React from 'react';

import { OrderLayoutProps } from 'types';

export const RosaOneLayout: React.FC<OrderLayoutProps> = ({ children }) => (
  <div className="tw-min-h-screen tw-bg-[linear-gradient(180deg,rgba(0,0,0,1)_50%,rgba(37,209,139,1)_100%)]">
    <div className="tw-flex tw-items-center tw-justify-center tw-flex-col tw-py-4 md:tw-py-12 tw-px-4 md:tw-px-8 tw-mx-auto tw-w-[min(100%,520px)] md:tw-w-[min(1180px,100%)]">
      {children}
    </div>
  </div>
);
